var _circle, _circle2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 35,
    cy: 35,
    r: 35,
    fill: "url(#paint0_linear_261_7009)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 35,
    cy: 35,
    r: 30,
    fill: "url(#paint1_linear_261_7009)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2971 18.878L19.4927 22.4012L19.3591 28.5556C19.2699 31.9892 19.4483 35.9584 19.7159 37.4304C20.9643 43.8516 25.6471 50.14 31.3999 53.0388C33.1391 53.886 34.8783 54.5996 35.3243 54.5996C37.2415 54.5996 42.4595 51.388 45.0459 48.6236C50.0407 43.272 51.4679 38.768 51.2895 28.9568L51.1559 22.4012L43.3515 18.878C39.0703 16.9604 35.4579 15.3996 35.3243 15.3996C35.1907 15.3996 31.5783 16.9604 27.2971 18.878ZM44.6891 28.5108L45.7595 29.6704L38.7583 36.6716L31.7567 43.6736L28.1891 40.106L24.6215 36.5828L25.6027 35.5568C26.1379 34.9772 26.7619 34.5316 27.0295 34.5316C27.2971 34.5316 28.4567 35.468 29.6163 36.6276L31.7567 38.7684L37.4647 33.06C40.5863 29.9384 43.2623 27.3964 43.3963 27.3964C43.5299 27.396 44.1095 27.8864 44.6891 28.5108Z",
    fill: "#03FF86"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_7009",
    x1: -1151.5,
    y1: 2375.8,
    x2: 3885.7,
    y2: 2375.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_7009",
    x1: -982,
    y1: 2041.4,
    x2: 3335.6,
    y2: 2041.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C957FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100BE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectedIcon);
export default __webpack_public_path__ + "static/media/ProtectedIcon.1f2e7162.svg";
export { ForwardRef as ReactComponent };